export default [{
  label: 'Checagem',
  value: 'checagem',
}, {
  label: 'Análise',
  value: 'análise',
}, {
  label: 'Pendente',
  value: 'pendente',
}, {
  label: 'Pré-aprovada',
  value: 'pré_aprovada',
}, {
  label: 'Recusada',
  value: 'recusada',
}, {
  label: 'Restrição',
  value: 'restrição',
}, {
  label: 'Desistência',
  value: 'desistencia',
}, {
  label: 'Aprovada',
  value: 'aprovada',
}, {
  label: 'Faturada',
  value: 'faturada',
}, {
  label: 'Pago',
  value: 'pago',
}];
